// One reader for the price a quote carries. The API hands it back in three
// shapes, depending on the endpoint:
//
//  - quote create / theft quote: { monthly, annual, default: { monthly,
//    annual }, theft: { monthly, annual } } — top level is the quote's type
//  - public quote: { total, default: { monthly: { instalment_amt, total },
//    annual: { total } }, theft: { ... } }
//  - pricing engine (/price): { total, gross, ipt, ... } — annual only
//
// The monthly instalment is its own figure, never a twelfth of the annual:
// monthly can carry a loading, so 12 × monthly may be more than the annual.
// Only the engine shape has no monthly, and only there is it derived.

// Minimum annual premium that can be split into monthly instalments.
export const MONTHLY_MIN = 100

function toNumber(value) {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? n : 0
}

// { monthly, annual, annualDiscount } for `type` ('default' | 'theft'), or for the quote's own
// type when none is given. Null when there's no usable annual figure.
export function coverPrice(price, type) {
  if (!price) return null
  let source = type ? price[type] : price
  // The engine shape only prices Theft + damage.
  if (!source && type === 'default' && !price.theft) source = price
  if (!source) return null

  const annual =
    typeof source.annual === 'object' && source.annual
      ? toNumber(source.annual.total)
      : toNumber(source.annual) || toNumber(source.total)
  if (!annual) return null

  const monthly =
    typeof source.monthly === 'object' && source.monthly
      ? toNumber(source.monthly.instalment_amt)
      : toNumber(source.monthly)

  // How much less annual costs than 12 instalments, in percent; 0 if unsent.
  const annualDiscount = toNumber(source.annual_discount)

  return { monthly: monthly || annual / 12, annual, annualDiscount }
}

// Pennies, for figures reported (GTM) rather than formatted for display.
export function roundMoney(value) {
  return Math.round((Number(value) || 0) * 100) / 100
}
